import { jwtDecode } from 'jwt-decode';
import { IJWTExpPayload } from './types';

export const decodeJwt = <T = IJWTExpPayload>(token: string): T | null => {
  try {
    return jwtDecode<T>(token);
  } catch {
    return null;
  }
};
